import {useNavigate} from 'react-router-dom';
import styles from './Header.module.scss';

function MarqueeBanner() {
    const navigate = useNavigate();

    const marqueeItems = [
        {text: 'На страже здоровья', link: '/delivery'},
        {text: 'Ветаптека', link: '/online-consult'},
        {text: 'Ветдиеты', link: '/promo'},
        {text: 'Работаем 10:00-19:00 пн-сб', link: '/schedule'},
        {text: 'Все препараты сертифицированы', link: '/quality'},
        {text: 'Записаться онлайн', link: '/gift'},
    ];

    return (
        <div className={styles.marqueeContainer}>
            <div className={styles.marquee}>
                <div className={styles.marqueeContent}>
                    {[...marqueeItems, ...marqueeItems].map((item, index) => (
                        <a
                            key={index}
                            href={item.link}
                            className={styles.marqueeItem}
                            onClick={(e) => {
                                e.preventDefault();
                                //navigate(item.link);
                            }}
                        >
                            <span className={styles.marqueeText}>{item.text}</span>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default MarqueeBanner;